import { module } from 'modujs';
import { Swiper, Navigation, Lazy } from 'swiper';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        Swiper.use([Navigation, Lazy]);

        this.length = this.$('item').length
        this.container = this.$('container')[0];
        this.arrowNext = this.$('next')[0]
        this.arrowPrev = this.$('prev')[0]

        this.gutter = 20 // Manually chosen to fit the gutter width $unit-small
        this.slidesPerView = this.getData('format') == 'square' ? 1.665 : 1.125 // Manually chosen to fit the grid system

        const args = {
            speed: 700,
            loop: false,
            spaceBetween: this.gutter,
            grabCursor: true,
            slidesPerView: this.slidesPerView,
            preloadImages: false,
            lazy: {
                loadPrevNext: true,
            },
            navigation: {
                prevEl: this.arrowPrev,
                nextEl: this.arrowNext
            }
        }

        if(this.length > 1) {
            this.carousel = new Swiper(this.container, args)
        }

    }

    destroy() {
        if(this.carousel && this.carousel.destroy) this.carousel.destroy()
    }
}
